import {
  Breadcrumb as BreadcrumbAntd,
  Card as CardAtnd,
  Typography as TypographyAntd,
} from 'antd';
import { Link as LinkDOM } from 'react-router-dom';
import styled from 'styled-components';

export const Card = styled(CardAtnd).attrs(props => ({
  /** PROPRIEDADES DO COMPONENTE */
  size: props.size || 'small',
  bodyStyle: {
    padding: '18px 15px',
    borderBottom: '2px solid #D9D9D9',
  },
}))`
  /** PROPRIEDADES CSS */
`;

export const Title = styled(TypographyAntd.Title).attrs(props => ({
  /** PROPRIEDADES DO COMPONENTE */
  level: props.level || 4,
}))`
  /** PROPRIEDADES CSS */
  margin-bottom: 0px !important;
  font-size: 18px !important;
`;

export const Breadcrumb = styled(BreadcrumbAntd)`
  display: flex;

  span {
    display: flex;
  }

  .ant-breadcrumb-separator {
    margin-bottom: 0px !important;
    font-size: 18px !important;
    font-weight: 600;
    line-height: 1.4;
    color: #424242;
  }
`;

export const Link = styled(LinkDOM)`
  text-decoration: none;
  color: #424242 !important;
  font-weight: 400;

  &:hover {
    font-weight: 600;
  }
`;
